module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/chevron-b9794b9c99c63d6c2d87ec1954f1e49b.svg";